import { useCallback, useEffect, useMemo, useState } from 'react';
import { collection, deleteDoc, doc, getDocs, query, where } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { db } from '../../config/firebaseConfig';
import { useTranslation } from '../../i18n/LanguageContext';

/**
 * Bekleyen (PENDING) izin talepleri: tek sorguyla çekilir; çalışan başına
 * sayılar ve "Bekleyen İzin Talepleri" penceresinin listesi buradan çıkar.
 */
const usePendingLeaveRequests = (employees) => {
  const { t } = useTranslation();
  const [requests, setRequests] = useState([]);

  // Bekleyen izin taleplerini getir
  const fetchPendingLeavesList = useCallback(async () => {
    try {
      const q = query(
        collection(db, 'LeaveRequests'),
        where('status', '==', 'PENDING')
      );
      const querySnapshot = await getDocs(q);
      setRequests(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (error) {
      console.error('Error fetching pending leaves list:', error);
    }
  }, []);

  useEffect(() => {
    fetchPendingLeavesList();
  }, [fetchPendingLeavesList]);

  // Çalışan bilgileriyle birlikte
  const pendingLeavesList = useMemo(() => requests.map((data) => {
    const employee = employees.find(emp => emp.id === data.employeeId);
    return {
      ...data,
      employeeName: employee ? `${employee.eName} ${employee.eSurname}` : 'Bilinmeyen Çalışan',
      employee,
    };
  }), [requests, employees]);

  const pendingLeaveCounts = useMemo(() => {
    const counts = {};
    requests.forEach(leave => {
      if (leave.employeeId) {
        counts[leave.employeeId] = (counts[leave.employeeId] || 0) + 1;
      }
    });
    return counts;
  }, [requests]);

  // İzin talebini sil
  const deleteLeaveRequest = async (requestId) => {
    try {
      const requestRef = doc(db, 'LeaveRequests', requestId);
      await deleteDoc(requestRef);

      toast.success(t('employees.toast.leaveDeleted'));

      // Listeyi yenile (bu aynı zamanda sayıları da güncelleyecek)
      await fetchPendingLeavesList();
    } catch (error) {
      console.error('Error deleting leave request:', error);
      toast.error(t('employees.toast.leaveDeleteError'));
    }
  };

  return { pendingLeaveCounts, pendingLeavesList, fetchPendingLeavesList, deleteLeaveRequest };
};

export default usePendingLeaveRequests;
